/**
 * Conversion config for the Props teaser upsell (mirrors os.tools' per-surface
 * `*Conversion.ts` + `buildPurchaseUrl`).
 *
 * One promo code per surface so the funnel is measurable — never reuse this code
 * on another page. The code must be minted and active in Stripe before ship;
 * the pricing page reads `coupon` from the query string and validates it.
 */

/** TODO: replace with the Stripe promo code minted for the Props tool page. */
export const PROPS_PROMO_CODE = 'PROPS20';
/** Shown in the CTA; keep in sync with the code's actual discount. */
export const PROPS_PROMO_LABEL = '20% off';

export const PROPS_PRICING_URL = 'https://www.stokastic.com/pricing';
export const SUPPORT_EMAIL = 'support@stokastic.com';

/** Locked rows at or above this EV are what the counter bar quantifies (matches the proxy). */
export const UPSELL_EV_THRESHOLD_PCT = 3;

/**
 * Tagged checkout link: preselects the Props tab + monthly interval, auto-applies
 * the promo code, and carries UTMs so the click is attributable.
 */
export const buildPropsPurchaseUrl = (league: string): string => {
  const params = new URLSearchParams({
    sport: 'props',
    interval: 'monthly',
    league: league.toLowerCase(),
    coupon: PROPS_PROMO_CODE,
    utm_source: 'tools',
    utm_medium: 'props_teaser',
    utm_campaign: `props_${league.toLowerCase()}`,
    utm_content: 'upsell_card',
  });
  return `${PROPS_PRICING_URL}?${params.toString()}`;
};

/**
 * GA4 event via the global `gtag` loaded in public/index.html. No-op when
 * analytics isn't present (dev, ad blockers) — tracking must never break the tool.
 */
export const trackPropsEvent = (name: string, params: Record<string, string | number>): void => {
  try {
    const g = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
    if (typeof g === 'function') g('event', name, params);
  } catch {
    /* ignore */
  }
};
